import Image from 'next/image';
import DallasImageProps from '../dallas-image-props';
import HappyPeaceSignSvg from './happy-peace-sign.svg';

export default function DallasImageHappyPeaceSign(props: DallasImageProps) {
  return <Image src={HappyPeaceSignSvg} alt="Happy peace sign" {...props} />;
}
